// extracted by mini-css-extract-plugin
export default {"emailInput":"sqwNUr","ssoEnterEmailInput":"iulMaz"};